import React from 'react';
import PropTypes from 'prop-types';
import { CaptionHeader } from '../Caption';

class ProductionCardHeader extends React.PureComponent {
  renderSaleOrRent() {
    switch (this.props.saleOrRent) {
      case 'sale':
        return 'Disponible para venta';
      case 'rent':
        return 'Disponible para arriendo';
      case 'both':
        return 'Disponible para venta y/o arriendo';
      default:
        return '';
    }
  }

  renderName() {
    if (this.props.gender) {
      return (
        <span className="capitalize">{`${this.props.gender} ${
          this.props.isDigital ? ' (Digital)' : ''
        }`}
        </span>
      );
    }
    return null;
  }

  render() {
    return (
      <CaptionHeader
        noBorder={this.props.isFree}
        title={this.props.name}
        titleUrl={`/production/${this.props.slug}`}
        subtitle={
          (this.props.theater &&
            !this.props.hideInfo &&
            this.props.theater.name) ||
          ''
        }
        subtitleUrl={
          (this.props.theater &&
            !this.props.hideInfo &&
            `/theater/${this.props.theater.slug}`) ||
          ''
        }
        subtitleIcon="masks"
      >
        <p className="mt-10 mb-0 italic">
          {this.renderName()}
          {this.props.year && this.props.year !== 0
            ? ` - ${this.props.year}`
            : ''}
          {this.props.saleOrRent && ` - ${this.renderSaleOrRent()}`}
        </p>
      </CaptionHeader>
    );
  }
}

ProductionCardHeader.propTypes = {
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  name: PropTypes.string,
  gender: PropTypes.string,
  year: PropTypes.number,
  saleOrRent: PropTypes.string,
  theater: PropTypes.object,
  hideInfo: PropTypes.bool,
  isFree: PropTypes.bool,
  isDigital: PropTypes.bool,
};

ProductionCardHeader.defaultProps = {
  name: '',
  gender: '',
  year: 0,
  saleOrRent: '',
  theater: {},
  hideInfo: false,
  isFree: true,
};

export default ProductionCardHeader;



// WEBPACK FOOTER //
// ./src/components/Cards/ProductionCardHeader.js